var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorPaymentCalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 52,
    viewBox: "0 0 41 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 48,
    rx: 2,
    fill: "#E6F0F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5107 2.43492C23.5107 3.1194 23.5165 3.69617 23.5095 4.27409C23.4875 6.11095 22.3363 7.28649 20.5122 7.2946C17.3851 7.3085 14.2592 7.30734 11.1321 7.29576C9.27213 7.28881 8.1267 6.11674 8.10933 4.24166C8.10353 3.66721 8.10817 3.09276 8.10817 2.4963C6.64308 2.4963 5.23938 2.42681 3.8461 2.5241C3.10487 2.57622 2.63813 3.17151 2.48641 3.92085C2.42966 4.20113 2.43429 4.49646 2.43429 4.78485C2.43198 18.6227 2.43198 32.4616 2.43314 46.2994C2.43314 48.0008 3.07592 48.6447 4.77148 48.6447C12.1247 48.6459 19.4779 48.6459 26.8311 48.6447C28.5371 48.6447 29.1845 48.0043 29.1869 46.3157C29.188 44.81 29.1787 43.3044 29.1961 41.7999C29.2031 41.1734 29.5598 40.7159 30.0833 40.592C30.6253 40.4646 31.1071 40.6012 31.3943 41.0842C31.5426 41.3332 31.6063 41.6668 31.6097 41.9621C31.6294 43.5442 31.641 45.1274 31.6132 46.7094C31.5692 49.2377 29.7822 51.0317 27.2539 51.0688C25.1506 51.1 23.0462 51.0769 20.943 51.0769C15.4811 51.0769 10.0191 51.0815 4.55722 51.0746C2.32195 51.0711 0.620601 49.818 0.138802 47.8132C0.0322504 47.3684 0.00792888 46.8959 0.00792888 46.4361C-0.00133648 32.501 -0.00133648 18.5671 0.00213803 4.63197C0.00213803 1.79677 1.79151 0.00623715 4.62439 0.00392081C12.0737 -0.00187004 19.5242 -0.000711865 26.9736 0.00392081C29.8401 0.00623715 31.6109 1.79098 31.6179 4.66903C31.6213 6.19318 31.6329 7.71849 31.6097 9.24264C31.5958 10.1553 30.8847 10.7054 30.0717 10.4877C29.5181 10.3394 29.195 9.87153 29.1903 9.15346C29.1811 7.66753 29.188 6.1816 29.1857 4.69567C29.1834 3.11361 28.5116 2.43955 26.9354 2.43608C25.8212 2.4326 24.7071 2.43492 23.5107 2.43492ZM10.5403 2.4604C10.5403 3.0638 10.5623 3.6012 10.5345 4.13627C10.5044 4.69914 10.7546 4.87866 11.2931 4.87287C13.1462 4.85434 14.9993 4.86592 16.8523 4.86592C18.0302 4.86592 19.2081 4.88561 20.3836 4.84854C20.6141 4.8416 21.016 4.63081 21.0322 4.48025C21.104 3.82125 21.0635 3.15067 21.0635 2.4604C17.5334 2.4604 14.0855 2.4604 10.5403 2.4604Z",
    fill: "#56ADFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.818 42.1595C16.8383 42.1595 17.8598 42.1502 18.8802 42.163C19.7349 42.1734 20.2607 42.6529 20.2549 43.3837C20.2503 44.111 19.7222 44.5836 18.8617 44.587C16.8198 44.5963 14.7791 44.5975 12.7373 44.587C11.8825 44.5824 11.3567 44.0971 11.3614 43.3663C11.3671 42.6378 11.893 42.1722 12.7546 42.163C13.7773 42.1514 14.7976 42.1595 15.818 42.1595Z",
    fill: "#56ADFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9993 24.2341C41.0021 23.8398 40.881 23.7662 40.518 23.7676C37.1822 23.7801 33.8464 23.7759 30.512 23.7759C27.1512 23.7759 23.7904 23.7801 20.4296 23.769C20.1027 23.7676 20.0123 23.8551 20.0137 24.1855C20.029 26.6445 20.0137 29.1049 20.0234 31.564C20.0332 34.0619 21.9459 35.9863 24.4442 35.9932C28.4894 36.0043 32.5347 36.003 36.5799 35.9863C37.0445 35.9849 37.5244 35.8933 37.9695 35.7544C39.8614 35.1657 41.0118 33.3482 40.9937 31.4279C40.9715 29.0286 40.977 26.632 40.9993 24.2341ZM26.0871 30.5351C25.4374 30.5351 24.9116 30.0102 24.9116 29.3618C24.9116 28.7134 25.4374 28.1885 26.0871 28.1885C26.7367 28.1885 27.2625 28.7134 27.2625 29.3618C27.2625 30.0089 26.7367 30.5351 26.0871 30.5351ZM30.4954 30.5351C29.8457 30.5351 29.3199 30.0102 29.3199 29.3618C29.3199 28.7134 29.8457 28.1885 30.4954 28.1885C31.145 28.1885 31.6708 28.7134 31.6708 29.3618C31.6708 30.0089 31.145 30.5351 30.4954 30.5351ZM34.9036 30.5351C34.254 30.5351 33.7282 30.0102 33.7282 29.3618C33.7282 28.7134 34.254 28.1885 34.9036 28.1885C35.5533 28.1885 36.0791 28.7134 36.0791 29.3618C36.0791 30.0089 35.5533 30.5351 34.9036 30.5351Z",
    fill: "url(#paint0_linear_3567_4113)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0637 21.9427C19.6213 19.274 21.534 16.908 24.2285 16.7761C24.5485 16.7609 24.9741 16.8497 25.1578 16.6803C25.3358 16.5179 25.2663 16.0847 25.301 15.7695C25.3497 15.3377 25.6989 15.0058 26.1162 15.0003C26.5113 14.9947 26.8896 15.3043 26.9495 15.7139C26.9856 15.9583 26.9828 16.2096 26.9828 16.4568C26.9828 16.6692 27.0552 16.7678 27.2889 16.7664C29.4297 16.7609 31.5692 16.7609 33.71 16.7664C33.934 16.7664 34.0314 16.6887 34.0258 16.4665C34.0202 16.2555 34.0161 16.043 34.0314 15.8334C34.0661 15.3502 34.4139 15.0114 34.8702 15.0003C35.2847 14.9892 35.6492 15.3321 35.702 15.7917C35.7243 15.9889 35.7521 16.1888 35.7396 16.3846C35.7201 16.6845 35.8467 16.7775 36.1333 16.7664C37.0806 16.7275 38.0015 16.847 38.8236 17.3551C40.2091 18.2118 40.899 19.4809 40.9853 21.0916C40.9992 21.3637 40.9867 21.6372 40.9867 21.9427C34.0021 21.9427 27.0315 21.9427 20.0637 21.9427Z",
    fill: "url(#paint1_linear_3567_4113)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3567_4113",
    x1: 24.5862,
    y1: 44.4887,
    x2: 34.623,
    y2: 16.6979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1270FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5223,
    stopColor: "#009EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5892,
    stopColor: "#17ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6933,
    stopColor: "#33BDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7971,
    stopColor: "#48C9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8998,
    stopColor: "#54D1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58D3FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3567_4113",
    x1: 22.3336,
    y1: 43.6748,
    x2: 32.3704,
    y2: 15.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5223,
    stopColor: "#009EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#14AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#31BCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7985,
    stopColor: "#47C9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    stopColor: "#54D0FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58D3FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorPaymentCalIcon);
export default __webpack_public_path__ + "static/media/tutorPaymentCalIcon.0a4410c5ed1b94a7fead91d2e2e992b5.svg";
export { ForwardRef as ReactComponent };